var ASSETS = {
    documentStatusCodes: {
        completed: {
            code: 120,
            description: "Cashiered - Auto Indexing Completed"
        },
        rejected: {
            code: 245,
            description: "Not Used/Rejected/Cancel/Void"
        },
        archived: {
            code: 255,
            description: "Archived"
        }
    },
    statuses: {
        issued: {},
        received: {},
        registered: {},
        rejected: {}
    }
};

module.exports = {
    documentStatusCodes: ASSETS.documentStatusCodes,
    statuses: ASSETS.statuses
};